export default "__VITE_ASSET__CFkWjvi5__"